module.exports = __webpack_public_path__ + "static/media/filter.db670609.svg";